export interface FileViewModel {
  title: string;
  fileName: string;
  description: string;
  fileUri: string;
  fileThumbnail: string;
  path: string;
  order: number;
}

export function isFileViewModel(value: any): value is FileViewModel {
  return value && typeof value === 'object' && 'fileName' in value && 'fileUri' in value;
}

export interface UserUploadedFileModel {
  id: number;
  projectId: number;
  fileName: string;
  fileUniqueName: string;
  fileSize: number;
  createdBy: string;
  createdByDisplayName?: string;
  createdDate: Date;
}

export function isUserUploadedFileModel(value: any): value is UserUploadedFileModel {
  return value && typeof value === 'object' && 'id' in value && 'fileName' in value && 'fileSize' in value;
}
